<template>
  <v-row
    aria-live="polite"
    aria-atomic="true"
    tabindex="0"
    align="center"
    justify="center"
    class="description-list-item"
  >
    <v-col
      v-if="!hideLabel"
      cols="6"
      class="description-list-label text-truncate"
      :class="labelFont"
      role="definition"
    >
      {{ label }}
    </v-col>
    <v-col
      :cols="hideLabel ? 12 : 6"
      class="description-list-description text-truncate"
      :title="description"
      :class="descriptionClasses"
    >
      {{ description }}
      <v-icon
        v-if="icon"
        :color="iconColor"
        :class="{
          'mb-1': $vuetify.breakpoint.smAndDown,
          'mb-2': $vuetify.breakpoint.mdAndUp
        }"
        :small="$vuetify.breakpoint.smAndDown"
        :large="$vuetify.breakpoint.mdAndUp"
      >
        {{ icon }}
      </v-icon>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'DescriptionListItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null,
      required: false
    },
    iconColor: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    labelFont () {
      return this.$vuetify.breakpoint.smAndDown ? 'caption' : 'subtitle-1'
    },
    descriptionFont () {
      return this.$vuetify.breakpoint.smAndDown ? 'body-2' : 'headline'
    },
    descriptionAlignment () {
      return this.hideLabel ? 'text-center' : ''
    },
    descriptionClasses () {
      return `${this.descriptionFont} ${this.descriptionAlignment}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../scss/variables';

.description-list-item {
  text-align: center;
  margin: 0;
  padding: 0 0 0 0;
  white-space: nowrap;

  .description-list-label {
    padding: 0;
    text-align: right;
    @media only screen and (min-width: 321px) {
      padding-right: map-get($spacers, 2);
    }
  }

  .description-list-description {
    font-weight: map-get($font-weights, 'bold');
    padding: 0;
    text-align: left;
  }
}
</style>
